module.exports = __webpack_public_path__ + "img/data-center.904be3d8.png";